import { useThemeTokens } from '@providers/themeTokenProvider';

export type TableTokens = {
  table: {
    headBackgroundColor?: string;
    headHoverBackgroundColor?: string;
    headTextColor?: string;
    cellTextColor?: string;
  };
};

export const useTableTokens = (overrides?: TableTokens): TableTokens => {
  const baseTokens = useThemeTokens();
  const { sys } = baseTokens;

  const comp: TableTokens = {
    table: {
      headBackgroundColor: sys.color.background,
      headHoverBackgroundColor: sys.color.neutralPressed,
      headTextColor: sys.color.onSurfaceVariant,
      cellTextColor: sys.color.onSurface,
      ...(overrides?.table ?? {}),
    },
  };
  return comp;
};
